import { css } from 'styled-components';
import {
  getSpacing, SpacingName, getTypography, TypographyName, ThemedFunctor,
} from '@doveit/lego';

export const list: ThemedFunctor = ({
  theme,
  $inline,
}) => css`
  display: flex;
  ${getSpacing.margin(theme, [SpacingName.NEGATIVE_SMALLER, 0, 0, SpacingName.NEGATIVE_SMALLER])}

  ${!$inline && `
    flex-wrap: wrap;
  `}
`;

export const item: ThemedFunctor = ({
  theme,
}) => css`
  display: inline-flex;
  flex-wrap: wrap;
  ${getSpacing.margin(theme, [SpacingName.SMALLER, 0, 0, SpacingName.SMALLER])}
  min-width: 6rem;
  flex-shrink: 0;
`;

export const tag: ThemedFunctor = ({
  theme,
}) => css`
  text-align: center;
  ${getTypography(theme, TypographyName.BODY)};
  box-sizing: border-box;
  padding: ${theme.spaceUnits.mobile.SMALLER} ${theme.spaceUnits.mobile.SMALL};
  line-height: 1;
  border: 1px solid ${theme.palettes.neutrals.light};
  border-radius: 5px;
  display: block;
  width: 100%;
`;
